import { render, staticRenderFns } from "./31.vue?vue&type=template&id=5c24efc7&scoped=true&"
var script = {}
import style0 from "./31.vue?vue&type=style&index=0&id=5c24efc7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c24efc7",
  null
  
)

export default component.exports